import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, EventEmitter, NgZone, OnDestroy, OnInit, Output, Renderer2, ViewChild, } from '@angular/core';
import { forkJoin as observableForkJoin, Observable, Subscription, range } from 'rxjs';
import { filter, timeout, delay, map } from 'rxjs/operators';
import { DomSanitizer } from '@angular/platform-browser';

import { Operation } from '../../../models/operation';
import { OperationItem } from '../../../models/operation-item';

import { SharedDataService } from '../../../services/shared-data.service';
import { AlgorithmsService } from '../../../services/algorithms.service';

import { DocumentType, SpreadingState } from '../../../utils/enums';
import { deepCopy, isEnvironmentHost } from '../../../utils/functions';
import { AutoUnsubscribe } from '../../../decorators/auto-unsubscribe';

@Component({
    selector: 'app-edit-sum-input',
    templateUrl: './edit-sum-input.component.html',
    styleUrls: ['./edit-sum-input.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
@AutoUnsubscribe('subsArr$')
export class EditSumInputComponent implements OnInit, OnDestroy {
  @Output() public formulaItemSelected = new EventEmitter();
  docType: DocumentType;
  docTypeOptions: typeof DocumentType = DocumentType;
  subsArr$: Subscription[] = [];
  showAutocomplete = true;
  closeOnFocusout = false;
  optionsList: any[] = [];



  constructor(private _algorithmService: AlgorithmsService,
              private _sharedDataService: SharedDataService,
              private _changeDetector: ChangeDetectorRef,
  ) {
    this.docType = _algorithmService.documentType;
  }

  ngOnInit(): void {
    this.subscribeForSharedData();
  }

  ngOnDestroy(): void {
    this._changeDetector.detach();
  }

  itemSelected(formulaOption: any): void {
    this.formulaItemSelected.emit(formulaOption);
    this.showAutocomplete = false;
    // give it a moment and reset form
    setTimeout(() => this.showInput(), 100);
  }

  showInput(): void {
    this.showAutocomplete = true;
    this._changeDetector.detectChanges();
  }

  private subscribeForSharedData() {
    this.subsArr$.push(this._sharedDataService.formulaOptions$.subscribe((formulaOptions: any[]) => {
      this.optionsList = formulaOptions;
    }));
  }
}
